module.exports = __webpack_public_path__ + "static/media/radiation.52c62738.svg";